import { styled } from '../theme';

const TableBody = styled('tbody')(({ theme }) => ({}));

export default TableBody;
